import { render, staticRenderFns } from "./ConfigurazioneGeneraleVociMenuListPage.vue?vue&type=template&id=fd7318b0"
import script from "./ConfigurazioneGeneraleVociMenuListPage.vue?vue&type=script&lang=js"
export * from "./ConfigurazioneGeneraleVociMenuListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports